module.exports = __webpack_public_path__ + "static/img/tianfangyuansucai1.6b5442e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tianfangyuansucai1.png
// module id = zGq5
// module chunks = 52